<template>
  <div class="news_center_wrap">
    <div class="title_container">
      <div class="title_box">
        <div class="title_1">NEWS CENTER</div>
        <div class="title_2">新闻动态</div>
        <div class="title_3"/>
      </div>
    </div>

    <!-- 卡片内容 -->
    <div class="card_container">
      <div class="card_wrap">
        <div class="card_box" v-for="(item, index) in newsData" :key="index" @click="handleNewsClick(item)">
          <div class="img_wrap"><img draggable="false" :src="item.img" :alt="item.title" class="img"></div>
          <div class="text_wrap">
            <div class="title_box text">{{ item.title }}</div>
            <div class="overview text">{{ item.overview }}</div>
            <p class="but_box">MORE</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { navigateToNews } from '@/utils/newsNavigation.js'

  export default {
    props: {
      newsData: {
        type: Array,
        default: () => {
          return []
        },
        required: true
      }
    },
    data() {
      return {

      }
    },
    methods: {
      async handleNewsClick(item) {
        const newsItem = {
          articleId: item.articleId || item.id,
          artType: item.artType || '0',
          category: item.category || 'enterprise'
        }
        // 使用默认的categoryPath 'enterprise'，因为推荐和最新新闻通常都是企业新闻
        await navigateToNews(newsItem, 'enterprise', this.$router)
      }
    }
  }
</script>

<style scoped>
.news_center_wrap {
  width: 100%;
  height: 100%;
  min-height: 300px;
  padding-top: 70px;
  padding-bottom: 90px;
}

.title_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 94%;
  max-width: 1320px;
  margin: 0 auto;
  .title_1 {
    line-height: normal;
    font-size: 60px;
    color: rgba(245,245,245,1);
    text-align: center;
    font-weight: bold;
    @media screen and (max-width: 768px){
      font-size: 30px;
    }
  }
  .title_2 {
    line-height: normal;
    text-align: center;
    font-size: 30px;
    color: rgba(5,85,182,1);
    margin-top: -30px;
    font-weight: normal;
    @mdedia screen and (max-width: 768px){
      font-size: 24px;
      margin-top: -20px;
    }
  }
  .title_3 {
    border-top-style: solid;
    border-top-width: 2px;
    border-top-color: rgb(5, 85, 182);
    width: 56px;
    margin: 16px auto 30px auto;
    @media screen and (max-width: 768px) {
      margin: 10px auto 20px auto;
    }
  }
}
.card_container{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 94%;
  max-width: 1280px;
  margin: 0 auto;

  .card_wrap {
    flex: 1 1 0;
    display: flex;
    @media screen and (max-width: 768px) {
      display: inline-block;
    }
  }
  .card_box {
    flex: 1;
    margin: 0 20px 20px 20px;
    background-color: rgba(255,255,255,1);
    @media screen and (max-width: 768px) {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: calc(100%/1);
    }
    &:hover .img{
      /* 鼠标移入指定子元素变化 */
      transform: scale(1.1);
    }
    .img_wrap {
      display: flex;
      width: 100%;
      max-height: 190px;
      overflow: hidden;
      img {
        flex: 1;
        max-width: 100%;
        max-height: 100%;
        object-fit: cover;
        transition: all 0.35s ease-in-out;
      }
    }
    .text_wrap {
      width: 100%;
      max-height: none;
      padding: 20px 0 10px;
      .text {
        display: -webkit-box;
        text-align: left;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .title_box {
        -webkit-line-clamp: 1;
        font-size: 16px;
        margin-bottom: 18px;
        color: rgba(51, 51, 51, 1);
        margin-top: 20px;
        &:hover {
          color: rgba(5,85,182,1);
          cursor: pointer;
        }
      }
      .overview {
        -webkit-line-clamp: 2;
        font-size: 14px;
        margin-bottom: 18px;
        color: rgba(145, 145, 145, 1);
        line-height: 2;
        &:hover {
          cursor: pointer;
        }
      }
      .but_box {
        width: 42px;
        line-height: 38px;
        font-size: 14px;
        color: rgba(5,85,182,1);
        border-bottom: 1px solid #0555b6;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
